const activate = (el) => {
    el.classList.add('active');
    el.style.pointerEvents = 'none';
};

const deactivate = (el) => {
    el.classList.remove('active');
    el.style.removeProperty('pointer-events');
};

const getKey = (el) => el.dataset.href.substring(1);

class NavigationMediator {
    constructor(el) {
        const root = typeof el === 'string' ? document.querySelector(el) : el;
        const items = [...root.querySelectorAll('[data-href]')];

        const map = new Map();

        items.forEach((item) => {
            const key = getKey(item);
            let arr;

            if (map.has(key)) {
                arr = map.get(key);
            } else {
                arr = [];
                map.set(key, arr);
            }

            arr.push(item);
        });

        this._map = map;
        this._items = items;

        this._id = '';
        this.hasStart = false;
    }

    setCurrentId(id) {
        if (typeof id !== 'string') {
            console.warn('Navigation id must be a string');

            return;
        }
        if (this._id === id || (id !== '' && !this._map.has(id))) return;

        const prevId = this._id;

        if (prevId !== '') this._map.get(prevId).forEach((item) => deactivate(item));
        if (id !== '') this._map.get(id).forEach((item) => activate(item));

        this._id = id;
    }
}

export default NavigationMediator;
